<if(input)>
    <h3 class="str-card-title">
        <str-textual-display ...(input || {}) useAccessibilityTxt=true/>
    </h3>
</if>
